import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  Renderer2,
  input,
} from '@angular/core';
import { Observable } from 'rxjs';

import { DotCmsPageContextFacade } from '../../../facades/dot-cms-page-context.facade';
import { DotCmsFacade } from '../../../facades/dot-cms.facade';
import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from '../../../models/dot-cms-content-types-component.model';
import { filterEmaDotcmsPageLinks, onClickEmaDotcmsPageLinks } from '../../../utils/dot-cms-utils';

@Component({
  selector: 'custom-dot-cms-blog',
  templateUrl: './dot-cms-blog.component.html',
  styleUrls: ['./dot-cms-blog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsBlogComponent implements DotCmsContentTypeComponent, OnChanges, OnInit, AfterViewInit {
  readonly identifier = input<string>(undefined);
  blogContentlet$: Observable<CustomDotCmsContentlet>;
  host$: Observable<string>;
  currentPageURI$: Observable<string>;
  previousUrl$: Observable<string>;
  constructor(
    private dotCmsFacade: DotCmsFacade,
    private dotCmsPageContextFacade: DotCmsPageContextFacade,
    private renderer: Renderer2,
    private el: ElementRef
  ) {}
  ngOnChanges() {
    this.host$ = this.dotCmsFacade.getDotCmsHost$;
    this.blogContentlet$ = this.dotCmsFacade.getContentletByIdentifier$(this.identifier());
    this.currentPageURI$ = this.dotCmsPageContextFacade.getCurrentPageURI$();
  }
  getTags(tagString: string): string[] {
    if (tagString) {
      return tagString.split(',');
    }
  }
  ngOnInit() {
    this.previousUrl$ = this.dotCmsFacade.getPreviousUrl();
    onClickEmaDotcmsPageLinks(this.el, this.renderer);
  }
  ngAfterViewInit() {
    filterEmaDotcmsPageLinks(this.el, this.renderer);
  }
}
